import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CasualHireFormService } from '../../casual-hire-form.service';

@Component({
    selector: 'gwc-frontend-order-confirmation',
    templateUrl: './order-confirmation.component.html',
    standalone: true
})
export class HireFormOrderConfirmationComponent implements OnInit {

	// @Public Properties


	// @Private Properties
	private _unsubscibeAll: Subject<any> = new Subject

	
	/**
	 * constructopr
	 */
	constructor(
		private _casualHireFormService: CasualHireFormService
	) {  }


	//--------------------------------------------------------------------------------
	// @Lifecycle Hooks
	//--------------------------------------------------------------------------------

	/**
	 * On Init
	 */
	ngOnInit(): void {
		
		this._casualHireFormService.deleteOrderData()

	}

	/**
	 * On DEstroy
	 */
	ngOnDestroy() {
		this._unsubscibeAll.next(null);
		this._unsubscibeAll.complete()
	}

	
	//--------------------------------------------------------------------------------
	// @Public Methods
	//--------------------------------------------------------------------------------


}
